import Config from '../launch/config'
// import Phaser from 'phaser'
import Matter from 'matter-js'

// export const setOrbitingShipProp = (id, key, value) => {
//     Object.keys(Config.entities).forEach((entityKey) => {
//         const {orbitingShips} = Config.entities[entityKey]
//         const arr = Object.keys(orbitingShips)

//         arr.length &&
//             arr.forEach((shipKey) => {
//                 if (shipKey === id) {
//                     orbitingShips[shipKey][key] = value
//                 }
//             })
//     })
// }

export const setShipDestination = ({numShips = 1, ship, x, y}) => {
    const boardSize = Config.boardSizes[Config.boardSize]
    const boardBuffer = 10
    let moveMarkerScale = 0.08

    if (ship.orbitingEntity) {
        ship.leavingOrbit = true
        ship.enteringOrbit = false
        ship.centeringOnPlanet = false
        ship.orbitGroup && ship.orbitGroup.remove(ship.sprite)
        delete ship.orbitingEntity.orbitingShips[ship.id]
        ship.orbitingEntity = null

        window.setTimeout(() => {
            ship.leavingOrbit = false
        }, 2000)
    }

    if (
        x < boardBuffer ||
        y < boardBuffer ||
        x > boardSize.boardWidth - boardBuffer ||
        y > boardSize.boardHeight - boardBuffer
    ) {
        return
    }

    // Wake up ship
    Matter.Sleeping.set(ship.sprite.body, false)

    // ship.thrustEmitter.start()
    ship.moving = true
    ship.selected = false
    delete Config.selectedShips[ship.id]

    ship.moveMarker && ship.moveMarker.destroy()
    ship.moveMarker = Config.scene.matter.add.sprite(x, y, 'moveMarker')
    ship.moveMarker[Config.namespace] = {type: 'moveMarker'}
    ship.moveMarker.setDepth(6)
    // ship.moveMarker.setTint(`0x${Config.colorGreen}`)

    Config.scene.matter.body.set(ship.moveMarker.body, {
        isSensor: true,
        isStatic: true,
    })
    ship.moveMarker.body[Config.namespace] = {
        isMoveMarker: true,
        numShips,
        shipId: ship.id,
    }

    if (ship.faction === Config.userFactionName) {
        // const maxScale = 0.4
        //
        // Object.keys(Config.selectedShips).forEach((key, index) => {
        //     if (moveMarkerScale <= maxScale) {
        //         moveMarkerScale += index * 0.1
        //     }
        // })

        ship.moveMarker.setScale(moveMarkerScale)
        ship.moveMarker.setVisible(true)
        ship.moveMarker.alpha = Config.moveMarkerAlpha

        // ship.moveLineGraphics = Config.scene.add.graphics({
        //     lineStyle: {width: 2, color: 0xffffff, alpha: Config.moveLineAlpha},
        // })
        // ship.moveLineGraphics[Config.namespace] = {type: 'moveLineGraphics'}
        //
        // ship.moveLine = new Phaser.Geom.Line(ship.x, ship.y, x, y)
    } else {
        ship.moveMarker.setVisible(false)
    }
}

export const getHealthBarColor = (health) => {
    const maxHealth = Config.shipMaxHealth
    let color = 0xffffff

    if (health < Math.floor(maxHealth / 1.42)) {
        color = 0xffff00 // yellow
    }

    if (health < Math.floor(maxHealth / 2)) {
        color = 0xffa500 // orange
    }

    if (health < Math.floor(maxHealth / 3.3)) {
        color = 0xff0000 // red
    }

    return color
}

export const deselectAllShips = () => {
    Object.keys(Config.selectedShips).forEach((key) => {
        const ship = Config.ships[key]

        if (ship && ship.selected) {
            ship.selected = false
        }

        if (Config.selectedShips[ship.id]) {
            delete Config.selectedShips[ship.id]
        }
    })
}
